var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('money-amount-field',_vm._b({attrs:{"max":_vm.max,"label":_vm.t('Amount')},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},'money-amount-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }